<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Liquidación</div>
        <span class="grey--text text--lighten-2">Detalle de las facturas cargadas por tipo de gasto</span>
        <div class='pt-2'><strong>{{ liquidacionCargada }}</strong> - {{ resumenLiquidacionCargado }}</div>
      </div>
    </v-card-title>
  
    <v-data-table
      :headers="cabecera"
      :items="detalle"
      hide-actions
      class="elevation-1 pa-2"
      no-data-text="Sin datos"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.FECHA | moment('DD/MM/YYYY')}}</td>
        <td class="text-xs-left">{{ props.item.DESCRIPCION }}</td>
        <td class="text-xs-left">{{ props.item.DESC_FORMA_DISTRIBUCION }}</td>
        <td class="text-xs-right">{{ props.item.IMPORTE | moneda }}</td>
        <td class="justify-center layout px-0">
          <!-- <v-btn small color="info" 
            v-if="props.item.DOCUMENTOS.length > 0"
            @click="verDocumento(props.item.DOCUMENTOS[0].URL)">Ver factura</v-btn> -->

          <v-btn small color="info" 
            v-if="props.item.DOCUMENTOS.length > 0"
            :to="{ path: '/liquidaciones/' + idLiquidacion + '/detalle/' + props.item.ID + '/documento/' + props.item.DOCUMENTOS[0].IDDOCUMENTO }"
          >
            Ver factura
          </v-btn>
          
        </td>
      </template>

    </v-data-table>
    
  </v-card>
  
 </template>

<style>
</style>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { LIQUIDACION_DETALLE_REQUEST } from '../store/actions/liquidaciones';

  export default {
    name: 'BrwDetalleLiquidacion',
    props: {
      'idLiquidacion': { type: Number, required: true },
      'idTipoGastoIngreso': { type: Number, required: true}
    },
    data: function () {
      return {
        cabecera: [
          {
            text: 'Fecha',
            align: 'left',
            sortable: true,
            value: 'FECHA'
          },
          {
            text: 'Descripción',
            align: 'left',
            sortable: true,
            value: 'DESCRIPCION'
          },
          {
            text: 'Forma de distribución',
            align: 'left',
            sortable: true,
            value: 'DESC_FORMA_DISTRIBUCION'
          },
          {
            text: 'Importe',
            align: 'right',
            sortable: true,
            value: 'IMPORTE'
          },
          {
            text: '',
            align: 'left',
            sortable: false
          }
          ]    
      }
    },
    created: function () {
      this.cargarDetalleLiquidacion()
    },
    
    methods: {
      cargarDetalleLiquidacion() {
        this.$store.dispatch(LIQUIDACION_DETALLE_REQUEST, {
          idLiquidacion: this.idLiquidacion,
          idTipoGastoIngreso: this.idTipoGastoIngreso
        })
      },
      verDocumento(url) {
        window.location = url
      }
    },
    filters: {
        moneda: function (value) {
            value = value.toLocaleString('es-ES', { style: 'currency', currency: 'EUR'})
            return value
        }
    },
    computed: {
      ...mapState({
        detalle: state => state.liquidaciones.detalle_liquidacion
      }),
      ...mapGetters([ 'liquidacionCargada', 'resumenLiquidacionCargado' ])
    }
  }
</script>